// src/routes/RoleAccessGuard.tsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { userType } from "../global/enums.ts";

interface RoleAccessGuardProps {
  children: React.ReactElement;
  allowedRoles: userType[];
}

const RoleAccessGuard: React.FC<RoleAccessGuardProps> = ({
  children,
  allowedRoles,
}) => {
  const loggedUserDetails = useSelector(
    (state: RootState) => state.user.userDetails
  );
  const currentUserType = String(
    loggedUserDetails?.UserType ?? userType.Guest
  ) as userType;

  if (!allowedRoles.includes(currentUserType)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RoleAccessGuard;
